import { render, staticRenderFns } from "./nomessage.vue?vue&type=template&id=29843eda&scoped=true"
import script from "./nomessage.vue?vue&type=script&lang=js"
export * from "./nomessage.vue?vue&type=script&lang=js"
import style0 from "./nomessage.vue?vue&type=style&index=0&id=29843eda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29843eda",
  null
  
)

export default component.exports